import { Component, DestroyRef, inject, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { NavigationStart, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, NgClass],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private readonly router = inject(Router);
  protected readonly authService = inject(AuthService);

  protected readonly operationsMenuOpen = signal(false);
  protected readonly techniciansMenuOpen = signal(false);

  protected readonly mobileMenuOpen = signal(false);

  constructor() {
    const destroyRef = inject(DestroyRef);
    const sub = this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => this.mobileMenuOpen.set(false));
    destroyRef.onDestroy(() => sub.unsubscribe());
  }

  protected toggleMobileMenu(): void {
    this.mobileMenuOpen.update((open) => !open);
  }

  protected closeMobileMenu(): void {
    this.mobileMenuOpen.set(false);
  }

  protected logout(): void {
    this.authService.logout();
  }

  protected toggleOperationsMenu(): void {
    this.techniciansMenuOpen.set(false);
    this.operationsMenuOpen.update((open) => !open);
  }

  protected closeOperationsMenu(): void {
    this.operationsMenuOpen.set(false);
  }

  protected toggleTechniciansMenu(): void {
    this.operationsMenuOpen.set(false);
    this.techniciansMenuOpen.update((open) => !open);
  }

  protected closeTechniciansMenu(): void {
    this.techniciansMenuOpen.set(false);
  }

  protected isOperationsRoute(): boolean {
    return this.router.url.startsWith('/dashboard') || this.router.url.startsWith('/dealers') || this.router.url.startsWith('/dealer-map') || this.router.url.startsWith('/vehicles') || this.router.url.startsWith('/inventory')
      || this.router.url.startsWith('/jobs') || this.router.url.startsWith('/scheduling');
  }

  protected isTechniciansRoute(): boolean {
    return this.router.url.startsWith('/technicians') || this.router.url.startsWith('/notifications') || this.router.url.startsWith('/my-jobs')
      || this.router.url.startsWith('/technician-inventory') || this.router.url.startsWith('/technician-performance') || this.router.url.startsWith('/nearby-dealers');
  }
}
